import { StudentFeedbackPage } from "@crm/ui/components/student-feedback/student-feedback-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/student-feedback/")({
  head: () => ({ meta: [{ title: "课程反馈 · imiker 学员工作台" }] }),
  component: StudentFeedbackPage,
});
